export default __webpack_public_path__ + "static/media/Harness of the Membranous.e11e6d2b.jpg";